@use "../../../sass/variables/colors";
@use "../../../sass/variables/typography";

:host {
  display: block;
  width: 100%;
  margin: 10px 0;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ux-copy {
    color: colors.$color-black;
    font-size: typography.$size-text-tiny;
    white-space: nowrap;
  }
}
